export default __webpack_public_path__ + "static/media/5-10-people.bd354730.png";